import { Controller } from '@hotwired/stimulus';
import { enter, leave } from '../../transition';

export default class extends Controller {
    static targets = ['mobileBackdrop', 'mobileContainer', 'mobilePanel', 'mobilePanelCloseBtn'];

    closeMobilePanel() {
        Promise.all([
            leave(this.mobileBackdropTarget),
            leave(this.mobilePanelTarget),
            leave(this.mobilePanelCloseBtnTarget)
        ]).then(() => {
            this.mobileContainerTarget.classList.add('hidden');
        });
    }

    async openMobilePanel() {
        this.mobileContainerTarget.classList.remove('hidden');
        enter(this.mobileBackdropTarget).then();
        enter(this.mobilePanelTarget).then();
        enter(this.mobilePanelCloseBtnTarget).then();
    }

    async toggleSidebar() {
        const sidebar = document.getElementById('desktop-sidebar');
        const mainContent = document.getElementById('main-content');

        // Optimistically assign the inverse class for instant UI feedback
        const currentlyCollapsed = sidebar?.classList.contains('is-collapsed') || false;
        const newVal = !currentlyCollapsed;

        if (sidebar) sidebar.classList.toggle('is-collapsed', newVal);
        if (mainContent) mainContent.classList.toggle('is-collapsed', newVal);

        try {
            const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
            await fetch('/academy/settings/toggle_sidebar', {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrfToken
                }
            });
        } catch (error) {
            console.error('Failed to save sidebar state to server:', error);
            // Revert on failure
            if (sidebar) sidebar.classList.toggle('is-collapsed', currentlyCollapsed);
            if (mainContent) mainContent.classList.toggle('is-collapsed', currentlyCollapsed);
        }
    }
}
